module.exports = __webpack_public_path__ + "img/business-360-1.73ec8475.png";